import React, { useState } from 'react';
import { Alert } from 'react-bootstrap';
import { PaymentForm } from '../PaymentForm';
import { useAuth } from '../../hooks/useAuth';
import { API_BASE_URL } from '../../config/api';
import { getAgentId } from '../../utils/agentId';

/**
 * PaymentFloatingForm - Payment creation form for floating window
 * Wraps shared PaymentForm with data loading and submission logic
 */
export default function PaymentFloatingForm({ onSubmit, onCancel }) {
  const { apiCall, user } = useAuth();
  const [error, setError] = useState(null);

  const handleSubmit = async (paymentData) => {
    try {
      setError(null);

      const agentId = await getAgentId(apiCall, user);

      await apiCall(`${API_BASE_URL}/payments`, {
        method: 'POST',
        body: JSON.stringify({
          ...paymentData,
          agent_id: agentId
        })
      });

      onSubmit?.();
    } catch (err) {
      setError(err.message || 'Failed to create payment');
      throw err;
    }
  };

  return (
    <>
      {error && (
        <Alert variant="danger" dismissible onClose={() => setError(null)}>
          {error}
        </Alert>
      )}
      <PaymentForm
        apiCall={apiCall}
        remoteCandidates
        onSubmit={handleSubmit}
        onCancel={onCancel}
        submitLabel="Tender Payment"
      />
    </>
  );
}
